<header class="header">

  <nav class="navbar border-bottom navbar-light bg-white header-navbar" aria-label="Offcanvas navbar large">
    <div class="container-fluid header-navbar__inner">
      <a title="Myexclusive Villas - Homepage" class="navbar-brand py-2 header-brand" [routerLink]="['/']">
        <img src="/assets/img/mxv2.png" alt="Myexclusive Villas - Homepage" title="Myexclusive Villas - Homepage"
          class="mxv-logo"><img src="/assets/img/icons/7.png" [src]="'/assets/img/icons/'+logoImage"
          title="Myexclusive Villas - Homepage" alt="Myexclusive Villas - Homepage" class="mxv-logo mxv-logo--badge"
          style="margin-left: 4px;">
      </a>

      <form *ngIf="!isHomeRoute()" [formGroup]="searchForm" (ngSubmit)="onSubmit()"
        class="header-search d-none d-md-flex" action="#" id="search" data-bs-dismiss="#offcanvas">
        <div class="header-search-shell" [class.is-expanded]="activeDesktopSearchPanel !== null">
          <button type="button" class="header-search-segment header-search-segment--where"
            [class.is-active]="activeDesktopSearchPanel === 'where'" (click)="setActiveDesktopPanel('where')">
            <!-- <span class="header-search-segment__label">Where</span> -->
            <span class="header-search-segment__value">{{ getDesktopWhereSummary() }}</span>
          </button>

          <button type="button" class="header-search-segment" [class.is-active]="activeDesktopSearchPanel === 'when'"
            (click)="setActiveDesktopPanel('when')">
            <span class="header-search-segment__value header-search-segment__value--inline">
              <span>{{ getDesktopWhenSummary() }}</span>
              <span *ngIf="getWhenFlexibilitySummary()" class="header-search-segment__meta">{{
                getWhenFlexibilitySummary() }}</span>
            </span>
          </button>

          <button type="button" class="header-search-segment header-search-segment--who"
            [class.is-active]="activeDesktopSearchPanel === 'who'" (click)="setActiveDesktopPanel('who')">
            <!-- <span class="header-search-segment__label">Who</span> -->
            <span class="header-search-segment__value">{{ getMobileWhoSummary() }}</span>
          </button>

          <button type="submit" class="header-search-submit" [class.header-search-submit--pulse]="searchSubmitPulse"
            aria-label="Search">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
        </div>

        <div class="header-search-panel" *ngIf="activeDesktopSearchPanel === 'where'">
          <app-location-typeahead #desktopWhereTypeahead [formControlName]="'searchbox'"
            placeholder="Search destinations" [bordered]="true" [emptyStateSuggestions]="headerEmptyStateSuggestions"
            [renderSuggestionsInline]="true" (locationSelected)="onLocationSelected($event)">
          </app-location-typeahead>
        </div>

        <div class="header-search-panel header-search-panel--calendar" *ngIf="activeDesktopSearchPanel === 'when'">
          <app-inline-calendar [calendarLayout]="'inline'" [startDate]="draftStartDate || mobileStartDate"
            [endDate]="draftEndDate || mobileEndDate" [calendarOptions]="mobileCalendarOptions"
            (datesSelected)="onMobileDatesSelected($event)">
          </app-inline-calendar>
          <div class="search-flexibility">
            <button type="button" class="search-flexibility__option" *ngFor="let option of flexibilityOptions"
              [class.is-active]="dateFlexibility === option.days" (click)="setDateFlexibility(option.days)">
              {{ option.label }}
            </button>

            <button type="button" class="header-search-flexibility__action"
              *ngIf="(draftStartDate && draftEndDate) || (mobileStartDate && mobileEndDate)" (click)="onSubmit()">
              Search
            </button>
          </div>
        </div>

        <div class="header-search-panel header-search-panel--guests" *ngIf="activeDesktopSearchPanel === 'who'">
          <app-guest-picker [guests]="mobileGuests" (guestsChanged)="onMobileGuestsChanged($event)"></app-guest-picker>
        </div>
      </form>

      <button type="button" class="header-search-mobile-compact d-flex d-md-none" (click)="openMobileSearch()"
        aria-label="Open search">
        <span class="header-search-mobile-compact__title">{{ getMobileWhereSummary() === 'Anywhere' ? 'Start your
          search' :
          getMobileWhereSummary() }}</span>
        <span class="header-search-mobile-compact__meta">{{ getMobileWhenSummary() }} • {{ getMobileWhoSummary()
          }}</span>
      </button>

      <div class="header-navbar__actions">
        <div class="header-desktop-links d-none d-xl-flex">
          <div class="dropdown">
            <button type="button" class="header-desktop-link dropdown-toggle" data-bs-toggle="dropdown"
              aria-expanded="false" aria-label="Open support menu">
              <i class="fa-solid fa-circle-question"></i>
              <span>Support</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" [routerLink]="['/page/f-a-q']">F.A.Q</a></li>
              <li><a class="dropdown-item" [routerLink]="['/contactus']">Contact Us</a></li>
            </ul>
          </div>

          <a class="header-desktop-link header-desktop-link--favorites" [routerLink]="['/user/favorites']"
            aria-label="Open favorites list" title="Favorites">
            <i class="fa-solid fa-heart"></i>
            <span>Favorites</span>
            <span class="header-desktop-link__count" *ngIf="favorites.length > 0">{{ favorites.length }}</span>
          </a>
        </div>

        <div class="dropdown d-none d-lg-inline-block">
          <button type="button" class="header-user-shortcut dropdown-toggle"
            [class.header-user-shortcut--logged-in]="loggedIn" data-bs-toggle="dropdown" aria-expanded="false"
            [attr.aria-label]="loggedIn ? 'Open account menu' : 'Sign in or sign up'">
            <i class="fa-solid" [class.fa-user]="loggedIn" [class.fa-right-to-bracket]="!loggedIn"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <ng-container *ngIf="loggedIn; else guestUserMenu">
              <li>
                <h6 class="dropdown-header header-user-menu-name"><i class="fa-solid fa-circle-user"></i>
                  {{ user?.firstname }} {{ user?.lastname }}</h6>
              </li>
              <li><a class="dropdown-item" [routerLink]="['/user/profile']"><i
                    class="fa-solid fa-user me-2"></i>Profile</a></li>
              <li><a class="dropdown-item" [routerLink]="['/user/bookings']"><i
                    class="fa-solid fa-calendar-check me-2"></i>My Bookings</a></li>
              <li><a class="dropdown-item" [routerLink]="['/user/favorites']"><i
                    class="fa-solid fa-heart me-2"></i>Favorites</a></li>
              <li><a class="dropdown-item" (click)="logout($event)"><i
                    class="fa-solid fa-right-from-bracket me-2"></i>Sign-Out</a></li>
            </ng-container>

            <ng-template #guestUserMenu>
              <li class="header-user-auth-row">
                <button type="button" class="dropdown-item header-user-auth-link" (click)="openLogin()">
                  <i class="fa-solid fa-right-to-bracket me-1"></i>Sign in
                </button>
                <span class="header-user-auth-separator">|</span>
                <button type="button" class="dropdown-item header-user-auth-link" (click)="openSignupModal()">
                  <i class="fa-solid fa-user-plus me-1"></i>Sign up
                </button>
              </li>
            </ng-template>
          </ul>
        </div>

        <button class="header-menu-toggle" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2"
          aria-controls="offcanvasNavbar2" aria-label="Open navigation menu">
          <span class="header-menu-toggle__icon"><i class="fa-solid fa-bars"></i></span>
        </button>
      </div>

      <div class="offcanvas offcanvas-end " tabindex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasNavbar2Label">Myexclusive Villas</h5>
          <button type="button" class="btn-close btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <div class="mobile-search-entry d-sm-none">
            <button type="button" class="mobile-search-launcher" (click)="openMobileSearch()"
              [class.mobile-search-launcher--hidden]="mobileSearchExpanded">
              <i class="fa fa-search"></i>
              <span>Start your search</span>
            </button>
          </div>

          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/areas']" data-bs-dismiss="offcanvas" aria-label="Close">
                <i class="fa fa-map-pin"></i>
                Destinations</a>
            </li>
            <li class="nav-item divider-left">
              <a class="nav-link" [routerLink]="['/blog']" data-bs-dismiss="offcanvas">Blog</a>
            </li>

            <li class="nav-item dropdown divider-left">
              <a class="nav-link dropdown-toggle" id="helpDropdownMenuLink" href="javascript:void(0)"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Support</a>
              <div class="dropdown-menu dropdown-menu-end" aria-labelledby="helpDropdownMenuLinkLink">
                <a [routerLink]="['/page/f-a-q']" class="dropdown-item" data-bs-dismiss="offcanvas"
                  aria-label="Close">F.A.Q</a>
                <a [routerLink]="['/contactus']" class="dropdown-item" data-bs-dismiss="offcanvas"
                  aria-label="Close">Contact Us</a>
              </div>
            </li>
            <li class="nav-item divider-left">


              <a [routerLink]="['/user/favorites']" routerLinkActive="router-link-active" class="nav-link  "
                title="favorites">
                <span class="badge  badge-secondary-light mr-2">
                  <i class="fas fa-heart text-secondary "></i>
                  {{favorites.length}} </span>
                Favorites
              </a>
            </li>

            <li class="nav-item divider-left" *ngIf="loggedIn != true">
              <a href="javascript:void(0)" class="nav-link" (click)="openLogin()" data-bs-dismiss="offcanvas"><i
                  class="fa-solid fa-right-to-bracket"></i>
                Login</a>
            </li>

            <li class="nav-item divider-left" *ngIf="loggedIn != true">
              <a href="javascript:void(0)" class="nav-link" (click)="openSignupModal()" data-bs-dismiss="offcanvas"><i
                  class="fa-solid fa-user-plus"></i>
                Sign-Up</a>
            </li>

            <li class="nav-item dropdown divider-left d-none d-lg-block" *ngIf="loggedIn">
              <a class="nav-link dropdown-toggle " href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">

                <i class="fa-solid fa-user"></i>
                {{ user.firstname }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end divider-left" aria-labelledby="navbarDropdown">
                <li>
                  <a class="dropdown-item" [routerLink]="['/user/profile']">My Profile</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink]="['/user/bookings']">My Bookings</a>
                </li>
                <!-- <li>
                <a class="dropdown-item" href="#">Refer A Property Owner</a>
              </li>
              <li>
                <a class="dropdown-item" href="#">Invite friends <small> get a 5% discount</small></a>
              </li> -->
                <li class="dropdown-divider"></li>
                <li>
                  <button (click)="logout($event)" class="dropdown-item" style="cursor: pointer">
                    <i class="fas fa-sign-out-alt mr-2 text-muted"></i> Log Out
                  </button>
                </li>

              </ul>

            </li>
            <li class="nav-item mt-3 mt-lg-0 ms-lg-3 d-lg-none d-xl-inline-block divider-left"><a
                class="btn btn-primary" rel="noopener" href="https://owners.myexclusivevillas.com">Owners Area</a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <ng-container *ngIf="mobileSearchExpanded">
    <div class="mobile-search-dialog-backdrop" (click)="closeMobileSearch()"></div>

    <div class="mobile-search-dialog" role="dialog" aria-modal="true" aria-label="Mobile search">
      <div class="mobile-search-dialog__body">
        <div class="mobile-search-dialog__header">
          <button type="button" class="btn-close" aria-label="Close" (click)="closeMobileSearch()"></button>
        </div>

        <div class="mobile-search-dialog__content">
          <div class="mobile-search-section"
            [class.mobile-search-section--active]="activeMobileSearchPanel === 'where'">
            <button type="button" class="mobile-search-summary" (click)="setActiveMobilePanel('where')">
              <span class="mobile-search-summary__label">Where</span>
              <span class="mobile-search-summary__value">{{ getMobileWhereSummary() }}</span>
            </button>
            <div class="mobile-search-panel" *ngIf="activeMobileSearchPanel === 'where'">
              <div class="mobile-search-panel__title">Where?</div>
              <app-location-typeahead placeholder="Search destinations" [bordered]="true"
                [emptyStateSuggestions]="headerEmptyStateSuggestions" [renderSuggestionsInline]="true"
                (locationSelected)="onMobileLocationSelected($event)">
              </app-location-typeahead>
            </div>
          </div>

          <div class="mobile-search-section" [class.mobile-search-section--active]="activeMobileSearchPanel === 'when'">
            <button type="button" class="mobile-search-summary" (click)="setActiveMobilePanel('when')">
              <span class="mobile-search-summary__label">When</span>
              <span class="mobile-search-summary__value">
                <span>{{ getMobileWhenSummary() }}</span>
                <span *ngIf="getWhenFlexibilitySummary()" class="mobile-search-summary__meta">{{
                  getWhenFlexibilitySummary() }}</span>
              </span>
            </button>
            <div class="mobile-search-panel mobile-search-panel--calendar" *ngIf="activeMobileSearchPanel === 'when'">

              <app-inline-calendar [calendarLayout]="'inline'" [startDate]="mobileStartDate" [endDate]="mobileEndDate"
                [calendarOptions]="mobileCalendarOptions" (datesSelected)="onMobileDatesSelected($event)">
              </app-inline-calendar>
              <div class="search-flexibility search-flexibility--mobile">
                <button type="button" class="search-flexibility__option" *ngFor="let option of flexibilityOptions"
                  [class.is-active]="dateFlexibility === option.days" (click)="setDateFlexibility(option.days)">
                  {{ option.label }}
                </button>
              </div>
            </div>
          </div>

          <div class="mobile-search-section" [class.mobile-search-section--active]="activeMobileSearchPanel === 'who'">
            <button type="button" class="mobile-search-summary" (click)="setActiveMobilePanel('who')">
              <span class="mobile-search-summary__label">Who</span>
              <span class="mobile-search-summary__value">{{ getMobileWhoSummary() }}</span>
            </button>
            <div class="mobile-search-panel" *ngIf="activeMobileSearchPanel === 'who'">
              <div class="mobile-search-panel__title">Who?</div>
              <app-guest-picker [guests]="mobileGuests" (guestsChanged)="onMobileGuestsChanged($event)">
              </app-guest-picker>
            </div>
          </div>
        </div>
      </div><!-- /body -->
      <div class="mobile-search-actions">
        <button type="button" class="btn btn-link mobile-search-clear" (click)="clearMobileSearch()">Clear
          all</button>
        <button type="button" class="btn btn-primary mobile-search-submit" (click)="onSubmit()">
          <i class="fa fa-search"></i>
          Search
        </button>
      </div>
    </div>
  </ng-container>


</header>